import WidgetKeyboardsContainer from 'components/WidgetKeyboards/WidgetKeyboardsContainer'
import WidgetKeyboardsPresentation from 'components/WidgetKeyboards/WidgetKeyboardsPresentation'
import WidgetKeyboardsData from 'components/WidgetKeyboards/WidgetKeyboardsData'

export default {
  Container: WidgetKeyboardsContainer,
  Presentation: WidgetKeyboardsPresentation,
  Data: WidgetKeyboardsData,
}
